import PropTypes from 'prop-types'

import { btnsTitle } from '@aytm/app/stats/page/question-views/sft/lib/utils'

export function HelpContent({ viewMode, btnsType }) {
  const { y, n } = btnsTitle(btnsType)
  const naLabel = btnsTitle('na')?.y ?? 'N/A'

  if ('bar' === viewMode) {
    return (
      <p>
        <b>Percentage of «{y}» answer</b>
        <br />
        <br />
        Shows the percentage of respondents whose aggregate explicit response is the «{y}» response.
      </p>
    )
  }

  if ('stacked' === viewMode) {
    return (
      <p>
        <b>
          Percentage of «{y}», «{n}», and {naLabel} responses
        </b>
        <br />
        <br />
        This view allows you to examine all respondents&apos; choices, {y}/{n} and the percentage of respondents that
        timed out.
      </p>
    )
  }

  return (
    <p>
      <b>Average Reaction Time by Percentage of «{y}»</b>
      <br />
      <br />
      This view plots the average reaction time for each word by the percentage of respondents who indicated «{y}».
    </p>
  )
}

HelpContent.propTypes = {
  viewMode: PropTypes.string,
  btnsType: PropTypes.string
}

export default HelpContent
